import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/navigation/PrivateRoute';
import SuperUserRoute from './components/navigation/SuperUserRoute';
import LoginPage from './pages/login/LoginPage';
import EsqueciSenhaPage from './pages/login/EsqueciSenhaPage';
import RecuperarSenhaPage from './pages/login/AtualizaSenhaPage';
import HomePage from './pages/HomePage';
import ModulePage from './pages/ModulePage';
import AcoesPage from './pages/acoes/AcoesPage';
import AcaoAreaPage from './pages/acoes/AcaoAreaPage';
import DashboardPage from './pages/visualizadorGeral/DashboardPage';
import UserAdminPage from './pages/admin/users/UserAdminPage';
import EditUserAccessPage from './pages/admin/users/EditUserAccessPage';
import EntityAdminPage from './pages/admin/entity/EntityAdminPage';
import QuestionAdminPage from './pages/admin/question/QuestionAdminPage';
import QuestionItemsPage from './pages/admin/question/QuestionItemsPage';
import QuestionActionsPage from './pages/admin/question/QuestionActionsPage';
import AdminPage from './pages/admin/AdminPage';
import ConformidadePage from './pages/conformidade/ConformidadePage';
import YearSelectionPage from './pages/YearSelectionPage';
import PublishQuestionsPage from './pages/admin/publish/PublishAdminPage';

const AppRoutes: React.FC = () => {
    const { isAuthenticated } = useAuth();

    return (
        <Switch>
            {/* Public Routes */}
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/esqueci-senha" component={EsqueciSenhaPage} />
            <Route exact path="/recuperar-senha" component={RecuperarSenhaPage} />

            {/* Protected Routes */}
            <PrivateRoute exact path="/home" component={HomePage} />
            <PrivateRoute exact path="/home/modulo" component={ModulePage} />
            <PrivateRoute exact path="/ano" component={YearSelectionPage} />
            <PrivateRoute exact path="/acoes" component={AcoesPage} />
            <PrivateRoute exact path="/acoes/:areaId" component={AcaoAreaPage} />
            <PrivateRoute exact path="/visualizadorgeral" component={DashboardPage} />
            <PrivateRoute exact path="/conformidade" component={ConformidadePage} />

            {/* Super User Routes - Admin Only */}
            <SuperUserRoute exact path="/admin" component={AdminPage} />
            <SuperUserRoute exact path="/admin/usuarios" component={UserAdminPage} />
            <SuperUserRoute exact path="/admin/users/:userId/access" component={EditUserAccessPage} />
            <SuperUserRoute exact path="/admin/entidade" component={EntityAdminPage} />
            <SuperUserRoute exact path="/admin/publicar" component={PublishQuestionsPage} />
            <SuperUserRoute exact path="/admin/questoes" component={QuestionAdminPage} />
            <SuperUserRoute exact path="/admin/questoes/:questionId/itens" component={QuestionItemsPage} />
            <SuperUserRoute exact path="/admin/questoes/:questionId/itens/:itemId/acoes" component={QuestionActionsPage} />

            {/* Catch all route - redirect to home if authenticated, login if not */}
            <Route path="*">
                <Redirect to={isAuthenticated ? "/home" : "/login"} />
            </Route>
        </Switch>
    );
};

export default AppRoutes; 